import ProgressBar from "./ProgressBar";

function FullScreenLoading({ isOpen }: { isOpen: boolean }) {
  const logo = require("../../assets/gdol.png")

  return (
    <>
      {
        isOpen == true &&
        <div className="w-screen h-screen bg-light-mode-2 dark:bg-dark-mode-2 z-50 absolute flex flex-col items-center justify-center gap-8">
          <div className="w-32">
            <img src={logo} alt="logo gdol" />
          </div>
          <div className="w-1/5">
            <ProgressBar />
          </div>
        </div>
      }
    </>
  );
}

export default FullScreenLoading;